// import Image1 from '@/images/featured-on/energy_national_geographic.png';
import Image2 from '@/images/featured-on/google-reviews-2.png';
// import Image3 from '@/images/featured-on/energypal-youtube.png';
import Image4 from '@/images/featured-on/best-of-houzz.png';
// import Image5 from '@/images/featured-on/innovative-renewable-energy-companies-2020.png';
import Image6 from '@/images/featured-on/energypal-innovative-top-10.jpg';
import NasdaqLogo from 'images/featured-on/Nasdaq-Logo.png';
import Image from 'next/legacy/image';
import SmartLink from '../Button/SmartLink';

export default function WeAreGrowing() {
  return (
    <>
      <div className="relative py-4 bg-gray-100 sm:py-8 lg:py-16">
        <div className="max-w-md px-4 mx-auto text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8">
          <h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            There&apos;s a reason we&apos;re growing
          </h2>
          <div className="mt-12">
            <div className="grid grid-cols-1 gap-24 lg:grid-cols-4 place-items-center">
              {/* <div className="flex justify-center">
                <Image src={Image1} alt="EnergyPal + National Geographic" />
              </div> */}
              <div className="grid  gap-y-4">
                <div className="relative h-44">
                  <Image
                    src={Image2}
                    alt="EnergyPal + Google"
                    layout="fill"
                    objectFit="contain"
                  />
                </div>
                <div>
                  <strong>Our customers love what we do for them</strong>
                  <div>
                    <SmartLink
                      href="/reviews"
                      className="font-bold text-primary hover:underline"
                    >
                      Read our reviews
                    </SmartLink>
                  </div>
                </div>
              </div>
              <div className="grid  gap-y-4">
                <div className="relative h-44">
                  <Image
                    src={NasdaqLogo}
                    alt="EnergyPal + Houzz Pro"
                    layout="fill"
                    objectFit="contain"
                  />
                </div>
                <div>
                  <strong>Best Solar Companies of 2023</strong>
                  <div>
                    <em>
                      &quot;EnergyPal offers multiple solar packages to meet the
                      energy needs of its customers.&quot;
                    </em>
                  </div>
                </div>
              </div>
              <div className="grid  gap-y-4">
                <div className="relative h-44">
                  <Image
                    src={Image4}
                    alt="EnergyPal + Houzz Pro"
                    layout="fill"
                    objectFit="contain"
                  />
                </div>
                <div>
                  <strong>Voted Best in Home Service</strong>
                  <div>(Solar &amp; Energy Providers)</div>
                </div>
              </div>
              <div className="grid  gap-y-4">
                <div className="relative flex items-center h-44">
                  <Image
                    src={Image6}
                    alt="EnergyPal Voted Best in Home Service"
                    className="rounded-lg"
                  />
                </div>
                <em>
                  &quot;EnergyPal was born to fix the solar buying experience
                  once and for all. 100% online, digital, and disrupting the
                  industry each day.&quot;
                </em>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
